import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { StoreService } from '../../core/store.service';
import { Cycle, CycleModel } from '../../shared';
import { EndWithSlash } from 'projects/lib-components/src/public_api';

@Component({
  selector: 'webstore-cycles',
  templateUrl: './admin.cycles.component.html',
  styleUrls: ['./admin.cycles.component.css']
})

export class AdminCyclesComponent implements OnInit {
  cyclesList: Cycle[];

  constructor(
    protected store: StoreService,
    protected http: HttpClient,
    protected router: Router
  ) { }


  ngOnInit(): void {
    this.store.showSplash(true);

    const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/cycle/getData/V2/INITDATA/0`;
    this.http.get<CycleModel>(destUrl).subscribe((data: CycleModel) => {
      if (!data.HasError) {
        if (data.CycleList.length === 0) {
          this.store.showAlert(this.store.getTrad('msgAdminCyc1'));
        } else {
          this.cyclesList = data.CycleList;
        }
      } this.store.showSplash(false);
    }, (error: any) => {
      JSON.stringify(error);
    });
  }
}


